import {
  Box,
  CircularProgress,
  useMediaQuery,
} from '@mui/material';
import { React, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from '@emotion/react';

import { eventsSideBarActions, sidebarActions } from '../../../store';

import LoaderContainer from '../LoaderContainer';
import DesktopHeader from '../DesktopHeader';
import TabPanel from '../TabPanel';
import CarTab from './Components/CarTab';
import DriversTab from './Components/DriversTab';

const CarCard = ({ isLoading, carInfo, positionInfo }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  const [currentTab] = useState(0);

  const padding = desktop ? '28px' : '16px';

  return (
    <div>
      {isLoading && (
        <LoaderContainer>
          <CircularProgress color="inherit" />
        </LoaderContainer>
      )}

      {desktop && (
      <Box position="relative" width="100%" padding={padding}>
        <DesktopHeader
          title="Eclipse Cross"
          onClose={() => {
            dispatch(sidebarActions.close());
            dispatch(eventsSideBarActions.close());
          }}
        />
      </Box>
      )}

      <TabPanel style={{ width: '100%' }} noPadding index={0} value={currentTab}>
        <CarTab carInfo={carInfo} positionInfo={positionInfo} />
      </TabPanel>

      <TabPanel style={{ width: '100%' }} noPadding index={1} value={currentTab}>
        <DriversTab drivers={carInfo?.drivers || []} />
      </TabPanel>

    </div>
  );
};

export default CarCard;
